// ambassadors
export const UPDATE_FORM_AMBASSADOR = 'UPDATE_FORM_AMBASSADOR'
export const SUBMITTING_AMBASSADOR_FORM = 'SUBMITTING_AMBASSADOR_FORM'
export const SUBMITTED_AMBASSADOR_FORM = 'SUBMITTED_AMBASSADOR_FORM'
export const ERROR_SUBMITTING_AMBASSADOR_FORM =
  'ERROR_SUBMITTING_AMBASSADOR_FORM'
export const RESET_AMBASSADOR = 'RESET_AMBASSADOR'
export const SET_NEXT_STEP = 'SET_NEXT_STEP'
export const UPDATING_AMBASSADOR = 'UPDATING_AMBASSADOR'
export const UPDATED_AMBASSADOR = 'UPDATED_AMBASSADOR'
export const ERROR_UPDATING_AMBASSADOR = 'ERROR_UPDATING_AMBASSADOR'
export const FETCHING_AMBASSADOR = 'FETCHING_AMBASSADOR'
export const RECEIVED_AMBASSADOR = 'RECEIVED_AMBASSADOR'
export const ERROR_FETCHING_AMBASSADOR = 'ERROR_FETCHING_AMBASSADOR'
export const FETCHING_AMBASSADOR_PAYMENTS = 'FETCHING_AMBASSADOR_PAYMENTS'
export const RECEIVED_AMBASSADOR_PAYMENTS = 'RECEIVED_AMBASSADOR_PAYMENTS'
export const ERROR_FETCHING_AMBASSADOR_PAYMENTS =
  'ERROR_FETCHING_AMBASSADOR_PAYMENTS'
export const CREATING_PENDING_PAYMENT = 'CREATING_PENDING_PAYMENT'
export const ADD_PENDING_PAYMENT = 'ADD_PENDING_PAYMENT'

// impressions
export const CREATE_IMPRESSION = 'CREATE_IMPRESSION'
export const CLEAR_IMPRESSIONS = 'CLEAR_IMPRESSIONS'

// user
export const FETCHING_VIEWER = 'FETCHING_VIEWER'
export const RECEIVED_VIEWER = 'RECEIVED_VIEWER'
export const UPDATING_VIEWER = 'UPDATING_VIEWER'
export const UPDATED_VIEWER = 'UPDATED_VIEWER'
export const ERROR_FETCHING_VIEWER = 'ERROR_FETCHING_VIEWER'
export const ERROR_UPDATING_VIEWER = 'ERROR_UPDATING_VIEWER'
// app
export const APP_INITIALISED = 'APP_INITIALISED'
export const FETCH_IP = 'FETCH_IP'
export const CHANGE_COUNTRY = 'CHANGE_COUNTRY'
export const POST_LOCAL_NOTIFICATION = 'POST_LOCAL_NOTIFICATION'
export const REMOVE_LOCAL_NOTIFICATION = 'REMOVE_LOCAL_NOTIFICATION'
export const ASKING_FOR_POSITION = 'ASKING_FOR_POSITION'
export const RECEIVED_POSITION = 'RECEIVED_POSITION'
export const GET_POSITION_DENIED = 'GET_POSITION_DENIED'

// auth
export const HANDLE_AUTH_MODAL = 'HANDLE_AUTH_MODAL'
export const IS_LOG_IN = 'IS_LOG_IN'
export const CONTINUE_SIGN_UP = 'CONTINUE_SIGN_UP'
export const SIGN_UP_BACK = 'SIGN_UP_BACK'
export const AUTHENTICATING = 'AUTHENTICATING'
export const LOG_IN = 'LOG_IN'
export const LOG_OUT = 'LOG_OUT'
export const INCORRECT_CREDENTIALS = 'INCORRECT_CREDENTIALS'
export const ERROR_AUTHENTICATING = 'ERROR_AUTHENTICATING'
export const HANDLE_TOKEN = 'HANDLE_TOKEN'

// brand
export const FETCHING_BRAND_PROVIDED_INFO = 'FETCHING_BRAND_PROVIDED_INFO'
export const RECEIVED_BRAND_PROVIDED_INFO = 'RECEIVED_BRAND_PROVIDED_INFO'
export const ERROR_FETCHING_BRAND_PROVIDED_INFO =
  'ERROR_FETCHING_BRAND_PROVIDED_INFO'

// like or unlike review comments
export const LIKING_COMMENT = 'LIKING_COMMENT'
export const UNLIKING_COMMENT = 'UNLIKING_COMMENT'

// review comments
export const UPDATED_REVIEWS = 'UPDATED_REVIEWS'
